// assets/review-upload.js
(function () {
  "use strict";

  // Local preview
  const imageInput = document.getElementById("review-images");
  const previewGrid = document.getElementById("image-preview");

  if (imageInput && previewGrid) {
    imageInput.addEventListener("change", (e) => {
      previewGrid.innerHTML = "";
      Array.from(e.target.files).slice(0, 5).forEach((file) => {
        const url = URL.createObjectURL(file);
        const img = document.createElement("img");
        img.src = url;
        img.alt = "Preview";
        img.className = "preview-img";
        img.onload = () => URL.revokeObjectURL(url);
        previewGrid.appendChild(img);
      });
    });
  }

  /**
   * Upload multiple images to Shopify CDN, return GID array
   * @param {File[]} files
   * @param {string} backendUrl
   * @returns {Promise<string[]>}
   */
  window.uploadReviewImages = async function (files, backendUrl) {
    const gids = [];

    for (const file of files) {
      // Step 1: Get Staged Upload credentials
      const urlRes = await fetch(`${backendUrl}/api/upload/get-url`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ filename: file.name, mimeType: file.type, fileSize: file.size }),
      });
      if (!urlRes.ok) throw new Error("Failed to get upload credentials");
      const { uploadUrl, resourceUrl, parameters } = await urlRes.json();

      // Step 2: Upload directly to Shopify CDN
      if (parameters && parameters.length > 0) {
        // multipart POST method
        const formData = new FormData();
        parameters.forEach(({ name, value }) => formData.append(name, value));
        formData.append("file", file);
        const uploadRes = await fetch(uploadUrl, { method: "POST", body: formData });
        if (!uploadRes.ok) throw new Error("Image upload failed");
      } else {
        // PUT method
        const uploadRes = await fetch(uploadUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file,
        });
        if (!uploadRes.ok) throw new Error("Image upload failed");
      }

      // Step 3: Register in Shopify Files, get GID
      const regRes = await fetch(`${backendUrl}/api/upload/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ resourceUrl, filename: file.name }),
      });
      if (!regRes.ok) throw new Error("Image registration failed");
      const { fileGid } = await regRes.json();
      gids.push(fileGid);
    }

    return gids;
  };
})();
